module.exports = __webpack_public_path__ + "images/news-3.2be75d4.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/news-3.png
// module id = 648
// module chunks = 0